import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "includes/Heading.js";
const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const ThreeColumn = tw.div`flex flex-wrap`;
const Column = tw.div``;
const HeadingColumn = tw(Column)`w-full xl:w-1/3`;
const CardColumn = tw(Column)`w-full md:w-1/2 xl:w-1/3 mt-16 xl:mt-0`;

const HeadingInfoContainer = tw.div`text-center xl:text-left max-w-lg xl:max-w-none mx-auto xl:mx-0`;
const HeadingTitle = tw(SectionHeading)`xl:text-left leading-tight`;
const HeadingDescription = tw.p`text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 mt-8`;

const Card = tw.div`mx-auto xl:mx-0 xl:ml-auto max-w-sm md:max-w-xs lg:max-w-sm xl:max-w-xs`;
const CardImage = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`h-80 bg-cover bg-center rounded`
]);

const CardText = tw.div`mt-4`;

const CardHeader = tw.div`flex justify-between items-center`;
const CardType = tw.div`text-primary-500 font-bold text-lg`;

const CardTitle = tw.h5`text-xl mt-4 font-bold`;

export default class ServiceTwo extends React.Component {


   cards = [];
   title = '';
    detail = '';

  constructor(props) {
    super(props);
    const cards = [];
    this.title = props.fieldData.title;
    this.detail = props.fieldData.detail;
    props.listData.forEach((single) => {
      cards.push(    {
        imageSrc: single.image,
        title: single.title,
        detail: single.detail
      });
    });
    this.cards = cards;
  }

  componentDidMount() {
  }

  render() {

    return (
        <Container className="w-80">
          <Content>
            <ThreeColumn>
              <HeadingColumn>
                <HeadingInfoContainer>
                  <HeadingTitle>{this.title}</HeadingTitle>
                  <HeadingDescription>
                    {this.detail}
                  </HeadingDescription>

                </HeadingInfoContainer>
              </HeadingColumn>
              {this.cards.map((card, index) => (
                  <CardColumn className="single-destination" key={index}>
                    <Card>
                      <CardImage imageSrc={card.imageSrc} />
                      <CardText>
                        <CardHeader>
                          <CardType className="destination-heading">{card.title}</CardType>

                        </CardHeader>
                        <CardTitle>{card.detail}</CardTitle>

                      </CardText>
                    </Card>
                  </CardColumn>
              ))}
            </ThreeColumn>
          </Content>
        </Container>
    );

  }
}
